import type { DriverRankTierEarningSettingEntity } from '@/features/driverEarningSetting/domain/entities/DriverRankTierEarningSettingEntity'

export class DriverRankTierConfigEntity {
  id?: string
  regionId?: number
  regionName?: string | null
  name?: string | null
  sortOrder?: number
  percentage?: number
  minRiders?: number | null
  maxRiders?: number | null
  minTotalWorkingHours?: number
  minOrders?: number
  minEffectiveDays?: number
  isActive?: boolean
  regionTotalActivePercentage?: number
  createdAt?: string
  updatedAt?: string
  driverEarningSetting?: DriverRankTierEarningSettingEntity | null
}
